
import { Component, forwardRef, Input, OnInit } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { MatTabsModule } from "@angular/material/tabs";
import { UserAddAvatarComponent } from "../../atoms/user-add-avatar/user-add-avatar.component";
import { CerrixSelectableUserListComponent } from "../cerrix-selectable-user-list/cerrix-selectable-user-list.component";
import { UserListInterface } from "../models/interfaces/user-list.model";
import { UserModel } from "../models/interfaces/user.model";
import { CerrixAvatarGroupComponent } from "./cerrix-avatar-group/cerrix-avatar-group.component";

@Component({
    selector: "cerrix-staffing",
    imports: [
    MatIconModule,
    MatTabsModule,
    forwardRef(() => CerrixAvatarGroupComponent),
    CerrixSelectableUserListComponent,
    UserAddAvatarComponent
],
    templateUrl: "./cerrix-staffing.component.html",
    styleUrl: "./cerrix-staffing.component.scss"
})
export class CerrixStaffingComponent implements OnInit {
    @Input() public userLists: UserListInterface[] = [];
    @Input() public selectedPermissionIndex: number = 0;
    @Input() public rolePermissionSelection: boolean = false;
    @Input() public editable: boolean = false;
    @Input() public dataUiid: string = "undefined";

    ngOnInit(): void {
        this.setSelectedIndex(this.selectedPermissionIndex);
    }

    selectRolePermission(selectedIndex: number) {
        if (!this.userLists[selectedIndex].disabled) {
            this.selectedPermissionIndex = selectedIndex;
        }
    }

    getSelectedUsers(): UserModel[] {
        const selectedList = this.userLists[this.selectedPermissionIndex];
        if (selectedList !== undefined) {
            return selectedList.selectableUsers.filter((x) => {
                return selectedList.users.includes(x.id);
            });
        }
        return [];
    }

    getMessageTypes(list: UserListInterface): string[] {
        let classList: string[] = [];
        if (list.messages !== undefined) {
            list.messages.forEach((message) => {
                if (message.type !== undefined && !classList.includes(message.type)) {
                    classList.push(message.type);
                }
            });
        }
        return classList;
    }

    setSelectedIndex(index: number) {
        for (let i = 0; i < this.userLists.length; i++) {
            if (!this.userLists[i].disabled) {
                this.selectedPermissionIndex = i;
                break;
            }
        }
    }
}
